<template>
  <div class="AchievementIndicator">
    <h4 ref="heading">{{ levelCopy }}</h4>
    <ul>
      <li v-for="(n, i) in totalStars" v-bind:key="(n, i)" :ref="`slot_${ i }`">
        <span :class="{ 'active': i + 1 <= achievementLevel }" :ref="`star_${ i }`"></span>
      </li>
    </ul>
    <h3 class="ranking" ref="ranking">{{ ranking }}</h3>
  </div>
</template>

<script>
import { TweenLite, TimelineLite, Expo } from 'gsap'

const levels = {
    1: 'NOVICE',
    2: 'ROOKIE',
    3: 'SPECIALIST',
    4: 'EXPERT',
    5: 'LEGEND'
}

export default {
  name: 'AchievementIndicator',
  props: {
    totalPossibleSucceses: Number,
    successfulHits: Number,
  },
  data() {
    return {
      totalStars: 5,
      level: this.$store.state.level
    }
  },
  mounted() {
    this.createAnimationTimeline()
  },
  computed: {
    locale() { return this.$store.state.lang.LOCALE },
    achievementLevel() {
      // Round to next greatest multple of 20
      let stars =  Math.ceil( ( this.successfulHits / this.totalPossibleSucceses * 100 ) / 20 ) * 20 / 10 / 2

      return stars > 0 ? stars : 1
    },
    ranking() {
        let rank = levels[this.achievementLevel]

        return this.locale[rank]
    },
    locale() { return this.$store.state.lang },
    levelCopy() {
        let { LOCALE, LEVEL } = this.$store.state.lang
        let copy;

        switch(LOCALE) {
          case 'tc':
          case 'sc':
            copy = `${ LEVEL.replace("0", this.level) }${ this.locale.ACHIEVEMENT }:`
            break;
          case 'en':
            copy = `${ LEVEL } 0${ this.level } ${ this.locale.ACHIEVEMENT }:`
            break;
          case 'fr':
            copy = `${ this.locale.ACHIEVEMENT } ${ LEVEL } 0${ this.level } :`
            break;
          default:
            copy = `${ LEVEL } 0${ this.level } ${ this.locale.ACHIEVEMENT }:`
        }

        return  copy;
    }
  },
  methods: {
    createAnimationTimeline() {
      const { ul, heading, ranking } = this.$refs

      TweenLite.set( heading, { autoAlpha: 0, y: '40%' } )
      TweenLite.set( ranking, { autoAlpha: 0, y: '40%' } )

      for (let i = 0; i < this.totalStars; i ++) {
        const slot = this.$refs[`slot_${ i }`]
        const star = this.$refs[`star_${ i }`]

        TweenLite.set( slot, { autoAlpha: 0, y: '40%' } )
        TweenLite.set( star, { scale: 0 } )

        this.animateElementsIn = new TimelineLite( { paused: false } )

        this.animateElementsIn
          .to( heading, 0.3, { autoAlpha: 1, y: '0%', ease: Expo.easeOut }, 0.3 )
          .to( slot, 0.3, { autoAlpha: 1, y: '0%', ease: Expo.easeOut }, (i * 0.1) + 0.3 )
          .to( star, 1, { scale: 1, ease: Expo.easeOut }, (i * 0.2) + 0.5 )
          .to( ranking, 0.6, { autoAlpha: 1, y: '0%', ease: Expo.easeOut }, 0.8 )
      }
    },
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .AchievementIndicator {

    @include brightnessContrastFilter();

    h4 {

      @include uppercaseText();

    }

    h3 {
        font-family: 'SF';
        font-weight: 600;
        text-transform: uppercase;
        font-size: rem( 55 );
        margin-top: rem( 10 );

        @include breakpoint( mobile-all ) {

            font-size: rem( 30 );
        }
    }

    ul {
      list-style: none;
      padding: 0;

      display: flex;
      justify-content: center;

      li {
        position: relative;

        display: block;
        margin: 0 rem( 3 );
        width: rem( 50 );
        height: rem( 50 );

        background: url('~@/assets/images/progress_indicator_dot_empty.png') no-repeat center center;
        background-size: contain;

        @include breakpoint( mobile-all ) {

          width: rem( 50 );
          height: rem( 50 );

        }

        span {

          position: absolute;
          left: 15%;
          top: 15%;

          width: 70%;
          height: 70%;

          display: block;

          &.active {

            background: url('~@/assets/images/progress_indicator_dot_fill.png') no-repeat center center;
            background-size: contain;

          }

        }

      }

    }

  }

</style>
